var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['countdown-wrapper']},[_c('span',[_vm._v("00")]),_vm._v(" "),_c('span',[_vm._v("04")]),_vm._v(" "),_c('span',[_vm._v("28")])])}
var staticRenderFns = []

export { render, staticRenderFns }